import type { Template } from "@/types";

export const PO_03_H1_V2: Template[] = [
    {
        id: "po-03-h1v2-01",
        name: "PO 01 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 61, y: 242, width: 621, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 242, width: 307, height: 432, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1006, y: 242, width: 307, height: 432, rotation: 0, imageRotation: 0 }
           
        ],
    },

    {
        id: "po-03-h1v2-02",
        name: "PO 02 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 61, y: 242, width: 307, height: 432, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 376, y: 242, width: 622, height: 432, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1006, y: 242, width: 307, height: 432, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-03-h1v2-03",
        name: "PO 03 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 81, y: 277, width: 259, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 277, width: 258, height: 362, rotation: 0, imageRotation: 0 },
            { id: "3", x: 760, y: 277, width: 540, height: 362, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-03-h1v2-04",
        name: "PO 04 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 77, y: 83, width: 237, height: 371, rotation: 0, imageRotation: 0 },
            { id: "2", x: 77, y: 462, width: 237, height: 371, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 83, width: 974, height: 751, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-05",
        name: "PO 05 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 138, y: 157, width: 213, height: 297, rotation: 0, imageRotation: 0 },
            { id: "2", x: 138, y: 462, width: 213, height: 297, rotation: 0, imageRotation: 0 },
            { id: "3", x: 359, y: 157, width: 876, height: 602, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-06",
        name: "PO 06 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 225, y: 83, width: 237, height: 371, rotation: 0, imageRotation: 0 },
            { id: "2", x: 225, y: 462, width: 237, height: 371, rotation: 0, imageRotation: 0 },
            { id: "3", x: 730, y: 258, width: 601, height: 400, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-03-h1v2-07",
        name: "PO 07 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 78, y: 83, width: 974, height: 750, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1060, y: 83, width: 237, height: 371, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1060, y: 462, width: 237, height: 371, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-08",
        name: "PO 08 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 139, y: 157, width: 876, height: 602, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1023, y: 157, width: 213, height: 297, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1023, y: 462, width: 213, height: 297, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-09",
        name: "PO 09 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 74, y: 277, width: 540, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 768, y: 277, width: 259, height: 362, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1035, y: 277, width: 258, height: 362, rotation: 0, imageRotation: 0 }
        ],
    },
];

